



























































































































import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'Privacy',
  // props: {
  // },
  components: {},
  setup: () => {
    return {};
  }
});
